"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconSocialFacebook = function SvgIconSocialFacebook(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "social facebook icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Social Facebook Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.881 16.793V13.9c0-1.388.917-1.72 1.567-1.72h3.962V6h-5.468c-6.063 0-7.424 4.581-7.424 7.538v3.255H16V24h3.55v18h7.064V24h5.236l.235-2.835.415-4.372h-5.619z"
  }));
};

var _default = SvgIconSocialFacebook;
exports.default = _default;